import axiosAuth from 'axios'

const instance = axiosAuth.create({
  baseURL: process.env.VUE_APP_API_BASEURL
})

instance.defaults.headers["Authorization"] = localStorage.getItem('token');

// Request interceptor: Automatically add forManager parameter to event-related requests only
instance.interceptors.request.use(
  (config) => {
    // Get current manager context and own manager ID from localStorage
    const currentForManagerId = localStorage.getItem('currentForManagerId');
    const ownManagerId = localStorage.getItem('ownManagerId');
    
    // Only add forManager to event-related endpoints
    const url = config.url || '';
    const isEventEndpoint = url.includes('/events/') || 
                           url.includes('/eventNews/') || 
                           url.includes('/eventInvoices/') ||
                           url.includes('/invoices');
    
    if (!isEventEndpoint) {
      return config;
    }
    
    // Only add forManager if:
    // 1. currentForManagerId is set AND valid (not null, not empty, not 'null')
    // 2. ownManagerId is set AND valid (not null, not empty, not 'null')
    // 3. currentForManagerId is different from ownManagerId (user is in external context)
    // NOTE: If currentForManagerId === ownManagerId, don't add parameter (user is in own context)
    const isValidExternalContext = currentForManagerId && 
                                   currentForManagerId !== 'null' && 
                                   currentForManagerId !== '' &&
                                   ownManagerId &&
                                   ownManagerId !== 'null' &&
                                   ownManagerId !== '' &&
                                   currentForManagerId !== ownManagerId;
    
    if (!isValidExternalContext) {
      return config;
    }
    
    // Parse URL manually (handle both absolute and relative URLs)
    const urlParts = url.split('?');
    const path = urlParts[0];
    const existingParams = urlParts[1] || '';
    
    // Parse existing query parameters
    const params = new URLSearchParams(existingParams);
    
    // Only add if not already present
    if (!params.has('forManager')) {
      params.set('forManager', currentForManagerId);
      
      // Reconstruct URL with new parameter
      const newParams = params.toString();
      config.url = newParams ? `${path}?${newParams}` : path;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance